import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { NavLink } from "react-router-dom";
import { Link, Typography } from "@mui/material";

import { handlerSelectItemEvent } from "tracking/google/analytics";
import StraightUpPresenter from "presenters/StraightUpPresenter";
import { appRoutes } from "routes";
import { useTemplateGroupTracking, useCategory } from "hooks";
import LazyLoad from "components/LazyLoad";
import Placeholder from "components/Placeholder";
import ResponsiveImage from "components/ResponsiveImage";
import { TEMPLATE_GROUP_TYPE_THUMB_ASPECT_RATIO, TEMPLATE_GROUP_TYPES } from "enums/templateGroup";

import useStyles from "./useStyles";

const STRAIGHT_UP_WIDTH = 400;

const StraightUp = ({ item, lazy, overflow, loading, isMasonryGrid, onClick, hasModulePosition = false }) => {
  const classes = useStyles({
    aspectRatio: TEMPLATE_GROUP_TYPE_THUMB_ASPECT_RATIO[TEMPLATE_GROUP_TYPES.straightUpEcard],
  });
  const { trackClick } = useTemplateGroupTracking(item);
  const { category } = useCategory();
  const handleClick = () => {
    trackClick();

    if (onClick) onClick(item);

    if (!hasModulePosition) handlerSelectItemEvent(item, category);
  };

  if (loading)
    return (
      <div data-testid="straightup-placeholder" className={classes.card}>
        <Placeholder variant="rect" ratio="4/3" />
      </div>
    );

  return (
    <Link onClick={handleClick} to={appRoutes.templateGroupPath(StraightUpPresenter.id(item))} component={NavLink}>
      <div className={classes.card}>
        {StraightUpPresenter.thumb(item) && (
          <LazyLoad lazy={lazy} overflow={overflow}>
            <ResponsiveImage
              src={StraightUpPresenter.thumb(item)}
              alt={StraightUpPresenter.name(item)}
              className={classes.cardImg}
              width={STRAIGHT_UP_WIDTH}
              widthMobile={226}
            />
          </LazyLoad>
        )}
        <div className={classes.cardOverlay} />
        <div className={clsx(classes.nameOverlay, { [classes.nameOverlayMasonry]: isMasonryGrid })}>
          <Typography
            variant="caption"
            align="center"
            className={clsx(classes.name, { [classes.nameMasonry]: isMasonryGrid })}
            title={StraightUpPresenter.name(item)}
          >
            {StraightUpPresenter.name(item)}
          </Typography>
        </div>
      </div>
    </Link>
  );
};

StraightUp.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    attributes: PropTypes.shape({}),
  }),
  lazy: PropTypes.bool,
  overflow: PropTypes.bool,
  loading: PropTypes.bool,
  isMasonryGrid: PropTypes.bool,
  onClick: PropTypes.func,
  hasModulePosition: PropTypes.bool,
};

export default StraightUp;
